export const menuData = {
  launchPad: {
    defaultMenuItems: [
      'Prodigy App Launcher',
      'Prodigy Admin',
      'Prodigy Appraisal Config',
      'Prodigy Process Manager',
    ],
    navMenuItems: [
      {
        title: 'Prodigy App Launcher',
        link: '/',
        iconClassName: 'fa-rocket',
      },
      {
        iconClassName: 'fa-admin',
        title: 'Prodigy Admin',
        link: '/maintenance',
      },
      {
        iconClassName: 'fa-admin-config',
        title: 'Prodigy Appraisal Config',
        link: '/appraisal-admin',
        right: 'AppraisalAdministration',
      },
      {
        iconClassName: 'fa-admin-process',
        title: 'Prodigy Process Manager',
        link: '/appraisal-process-manager',
        right: 'Prodigy Process Manager',
      },
    ],
    routesOpenState: {},
    needSuffixItems: ['Prodigy Admin'],
    needExtraSuffixItems: ['Prodigy Admin'],
  },
  equityFinder: {
    defaultMenuItems: ['Prodigy App Launcher', 'Dashboard', 'Data Import'],
    navMenuItems: [
      {
        title: 'Prodigy App Launcher',
        link: '/',
        iconClassName: 'fa-rocket',
      },
      {
        title: 'Dashboard',
        link: '/equityFinder/dashboard',
      },
      {
        title: 'Prodigy Equifinder',
        link: '',
        child: [
          {
            title: 'Property Search',
            link: '/equityFinder/propertyList',
            child: [
              {
                title: 'Summary',
                link: '/equityFinder/subject',
              },
              {
                title: 'Regression Analysis',
                link: '/equityFinder/regressionAnalysis',
              },
              {
                title: 'Master List',
                link: '/equityFinder/masterList',
              },
              {
                title: 'Version List',
                link: '/equityFinder/versionList',
              },
              {
                title: 'Presentation',
                link: '/equityFinder/presentation',
                dependsReadOnlyFlag: true,
              },
            ],
          },
          {
            title: 'App Settings',
            link: '',
            right: 'EquiFinderMaintainAppSettings',
            dependsReadOnlyFlag: true,
            child: [
              {
                title: 'Global Library Manager',
                link: '/equityFinder/globalLibrary',
              },
              {
                title: 'Configurations',
                link: '/equityFinder/configurations/rule',
              },
              {
                title: 'Global Scoring Rules',
                link: '/equityFinder/globalconfigurations',
              },
              {
                title: 'Refresh Cache',
                link: '',
                action: 'refresh-cache',
              },
            ],
          },
        ],
      },
      {
        title: 'Data Import',
        link: '/equityFinder/dataload',
        right: 'EquiFinderMaintainDataImports',
        child: [
          {
            title: 'Import Log',
            link: '/equityFinder/datalog',
          },
        ],
      },
    ],
    routesOpenState: {
      dashboard: 'Prodigy Equifinder',
      propertyList: 'Prodigy Equifinder_Property Search',
      subject: 'Prodigy Equifinder_Property Search',
      masterList: 'Prodigy Equifinder_Property Search',
      versionList: 'Prodigy Equifinder_Property Search',
      presentation: 'Prodigy Equifinder_Property Search',
      regressionAnalysis: 'Prodigy Equifinder_Property Search',
      globalLibrary: 'Prodigy Equifinder_App Settings',
      configurations: 'Prodigy Equifinder_App Settings',
      globalconfigurations: 'Prodigy Equifinder_App Settings',
      datalog: 'Data Import',
    },
    needSuffixItems: [
      'Summary',
      'Regression Analysis',
      'Master List',
      'Version List',
      'Presentation',
    ],
    needExtraSuffixItems: [
      'Regression Analysis',
      'Master List',
      'Version List',
    ],
  },
  maintenance: {
    defaultMenuItems: [
      'Prodigy App Launcher',
      'Role Admin',
      'User Admin',
      'Tax Transparency Admin',
      'Public Portal Admin',
      'Public Website Admin',
      'Maintenance Admin',
      'Electronic Correspondence',
      'Revision History Search',
    ],
    navMenuItems: [
      {
        title: 'Prodigy App Launcher',
        link: '/',
        iconClassName: 'fa-rocket',
      },
      {
        title: 'Role Admin',
        link: '/maintenance/modules',
      },
      {
        title: 'User Admin',
        link: '/maintenance/users',
        child: [
          {
            title: 'Internal Users',
            link: '/maintenance/users/internal',
          },
          {
            title: 'Private Portal Users',
            link: '/maintenance/users/private',
          },
          {
            title: 'Public Portal Users',
            link: '/maintenance/users/public',
          },
          {
            title: 'User Status',
            link: '/maintenance/status-users',
          },
        ],
      },
      {
        title: 'Tax Transparency Admin',
        link: '/maintenance/tax-transparency',
        right: 'TaxTransparencyAdmin',
      },
      {
        title: 'Public Portal Admin',
        link: '/maintenance/public-portal',
        right: 'PublicPortalAdmin',
      },
      {
        title: 'Public Website Admin',
        link: '/maintenance/public-website',
        right: 'PublicWebsiteAdmin',
      },
      {
        title: 'Maintenance Admin',
        link: '/maintenance/maintenance-admin',
        right: 'MaintenanceMessageEdit',
      },
      {
        title: 'Electronic Correspondence',
        link: '/maintenance/electronic-correspondence',
      },
      {
        title: 'Revision History Search',
        link: '/maintenance/revision-history-search',
      },
      {
        title: 'Daily Jobs Admin',
        link: '/maintenance/daily-jobs',
        right: 'AppraisalAdministrationEnableJobs',
      },
    ],
    routesOpenState: {},
    needSuffixItems: [],
  },
  mra: {
    defaultMenuItems: ['Prodigy App Launcher'],
    navMenuItems: [
      {
        title: 'Prodigy App Launcher',
        link: '/',
        iconClassName: 'fa-rocket',
      },
      {
        title: 'Prodigy MRA',
        link: '',
        child: [
          {
            title: 'Models',
            link: '/mra/models',
            child: [
              {
                title: 'Model',
                link: '/mra/model',
              },
            ],
          },
          {
            title: 'Settings',
            link: '/mra/settings',
          },
        ],
      },
    ],
    routesOpenState: {
      models: 'Prodigy MRA',
      model: 'Prodigy MRA_Models',
      settings: 'Prodigy MRA',
    },
    needSuffixItems: ['Model'],
  },
  appraisalDemo: {
    defaultMenuItems: ['Prodigy App Launcher', 'Dashboard', 'Property Search'],
    navMenuItems: [
      {
        title: 'Prodigy App Launcher',
        link: '/',
        iconClassName: 'fa-rocket',
      },
      {
        title: 'Dashboard',
        link: '/apprdemo/dashboard',
      },
      {
        title: 'Property Search',
        link: '/apprdemo/search',
        child: [
          {
            title: 'Summary',
            link: '/apprdemo/summary',
          },
          {
            title: 'Identification',
            link: '',
          },
          {
            title: 'Owner & Deed',
            link: '',
          },
          {
            title: 'Cost Approach',
            link: '',
          },
          {
            title: 'Market Approach',
            link: '',
          },
          {
            title: 'BPP Valuation',
            link: '',
          },
          {
            title: 'Mineral Valuation',
            link: '',
          },
          {
            title: 'Value Reconciliation',
            link: '',
          },
          {
            title: 'Assessment',
            link: '',
          },
          {
            title: 'Document Imaging',
            link: '',
          },
          {
            title: 'Market Area Profile',
            link: '/apprdemo/market',
          },
        ],
      },
    ],
    routesOpenState: {
      summary: 'Property Search',
      market: 'Property Search',
    },
    needSuffixItems: ['Summary'],
  },
  appraisal: {
    defaultMenuItems: [
      'Prodigy App Launcher',
      'App Functions',
      'App Settings',
      'Dashboard',
      'Property Search',
      'Owner Search',
      'Agent Search',
      'Mortgage Lender Search',
      'Evaluation',
    ],
    navMenuItems: [
      {
        title: 'Prodigy App Launcher',
        link: '/',
        iconClassName: 'fa-rocket',
      },
      {
        title: 'Dashboard',
        link: '/appraisal/dashboard',
      },
      {
        title: 'Property Search',
        link: '/appraisal/property/search',
      },
      {
        title: 'Property Equity Search',
        link: '/appraisal/equity-property/search',
      },
      {
        title: 'Owner Search',
        link: '/appraisal/owner/search',
        child: [
          {
            title: 'Owner Record',
            link: '/appraisal/ownerRecord',
          },
        ],
      },
      {
        title: 'Agent Search',
        link: '/appraisal/agent/search',
        child: [
          {
            title: 'Agent Record',
            link: '/appraisal/agentRecord',
          },
        ],
      },
      {
        title: 'Mortgage Lender Search',
        link: '/appraisal/mortgagelender/search',
        child: [
          {
            title: 'Mortgage Lender Record',
            link: '/appraisal/mortgagelenderRecord',
          },
        ],
      },
      {
        title: 'Evaluation',
        link: '/appraisal/evaluation',
      },
      {
        title: 'App Functions',
        child: [
          {
            title: 'Create New',
            child: [
              {
                title: 'Create Property',
              },
              {
                title: 'Create Owner',
                link: '/appraisal/owner/create',
              },
              {
                title: 'Create Agent',
                link: '/appraisal/agent/create',
              },
              {
                title: 'Create Taxing Unit',
              },
              {
                title: 'Create Mortgage',
                link: '/appraisal/mortgagelender/create',
              },
            ],
          },
          {
            title: 'Walkthrus',
            child: [],
          },
        ],
      },
      {
        title: 'App Settings',
        child: [
          {
            title: 'UI Maintenance',
            child: [
              {
                title: 'Page Library',
                link: '/appraisal/webpages',
              },
              {
                title: 'Sub Component',
                link: '/appraisal/subcomponents',
              },
              {
                title: 'Menu Profiles',
                link: '/appraisal/menuprofiles',
              },
              {
                title: 'Menu Defaults',
                link: '/appraisal/menu-defaults',
              },
              {
                title: 'Codefile Maintenance',
                link: '/appraisal/codefile-maintenance',
              },
            ],
          },
        ],
      },
    ],
    routesOpenState: {
      ownerRecord: 'Owner Search',
      agentRecord: 'Agent Search',
      mortgagelenderRecord: 'Mortgage Lender Search',
    },
    routesOpenWhenInChild: {
      property: 'Property Search',
    },
    needSuffixItems: ['Owner Record', 'Agent Record', 'Mortgage Lender Record'],
  },
};

export const widgetData = {
  appraisal: {
    summary: [
      {
        id: 'appraisal-summary-propertyHeader',
        title: 'Property Header',
        level: 0,
        items: [
          {
            id: 'propID',
            title: 'Property',
          },
          {
            id: 'geoID',
            title: 'GEO ID',
          },
          {
            id: 'propType',
            title: 'Property Type',
          },
          {
            id: 'subdivisionCd',
            title: 'Abstract / Subdivision',
          },
          {
            id: 'structureStateCd',
            title: 'State Code',
          },
          {
            id: 'Zoning',
            title: 'Zoning',
          },
          {
            id: 'Status',
            title: 'Status',
          },
          {
            id: 'neighborhood',
            title: 'NBHD Code',
          },
        ],
      },
      {
        id: 'appraisal-summary-detailSection',
        title: 'Detail Section',
        level: 0,
      },
      {
        id: 'appraisal-summary-analyticsSection',
        title: 'Analytics Section',
        level: 0,
      },
      {
        parent: 'appraisal-summary-detailSection',
        id: 'appraisal-summary-cardsSection',
        title: 'Cards Section',
        level: 1,
      },
      {
        parent: 'appraisal-summary-detailSection',
        id: 'appraisal-summary-tableSection',
        title: 'Value Table',
        level: 1,
      },
      {
        parent: 'appraisal-summary-analyticsSection',
        id: 'appraisal-summary-googlemapSection',
        title: 'Google Map',
        level: 1,
      },
      {
        parent: 'appraisal-summary-analyticsSection',
        id: 'appraisal-summary-bingMapSection',
        title: 'Bing Map',
        level: 1,
      },
      {
        parent: 'appraisal-summary-analyticsSection',
        id: 'appraisal-summary-chartSection',
        title: 'Chart',
        level: 1,
      },
      {
        parent: 'appraisal-summary-cardsSection',
        id: 'appraisal-summary-cardOwner',
        title: 'Owner',
        level: 2,
      },
      {
        parent: 'appraisal-summary-cardsSection',
        id: 'appraisal-summary-cardLegal',
        title: 'Legal',
        level: 2,
      },
      {
        parent: 'appraisal-summary-cardsSection',
        id: 'appraisal-summary-cardSitus',
        title: 'Situs',
        level: 2,
      },
      {
        parent: 'appraisal-summary-cardsSection',
        id: 'appraisal-summary-cardExemption',
        title: 'Exemptions',
        level: 2,
      },
      {
        parent: 'appraisal-summary-cardsSection',
        id: 'appraisal-summary-cardTaxing',
        title: 'Taxing Unit',
        level: 2,
      },
      {
        parent: 'appraisal-summary-cardsSection',
        id: 'appraisal-summary-cardLand',
        title: 'Land Size',
        level: 2,
      },
    ],
    dashboard: [
      {
        id: 'appraisal-dashboard-userSpecific',
        title: 'User Specific',
        level: 0,
      },
      {
        id: 'appraisal-dashboard-roleSpecific',
        title: 'Role specific',
        level: 0,
      },
      {
        id: 'appraisal-dashboard-cad',
        title: 'Cad',
        level: 0,
      },
      {
        parent: 'appraisal-dashboard-userSpecific',
        id: 'appraisal-dashboard-clientServices',
        title: 'Client Services',
        level: 1,
      },
      {
        parent: 'appraisal-dashboard-userSpecific',
        id: 'appraisal-dashboard-appraisalDept',
        title: 'Appraisal Dept',
        level: 1,
      },
      {
        parent: 'appraisal-dashboard-userSpecific',
        id: 'appraisal-dashboard-residentialAnalysis',
        title: 'Residential Analysis',
        level: 1,
      },
      {
        parent: 'appraisal-dashboard-roleSpecific',
        id: 'appraisal-dashboard-residentialBar',
        title: 'Residential Bar',
        level: 1,
      },
      {
        parent: 'appraisal-dashboard-roleSpecific',
        id: 'appraisal-dashboard-landDepartment',
        title: 'Land Department',
        level: 1,
      },
    ],
  },
};
export const fetchingState = {
  FETCHING: 'fetching',
  SAVING: 'saving',
  LOADED: 'loaded',
  ERROR: 'error',
};

export const simpleInputOperators = ['=', '>', '<', '>=', '<=', 'like'];
export const textOperators = ['=', 'in', 'like'];
export const defaultPageSize = 50;
export const savedSearchLimit = 10;

export const MAX_PRESENTATION_SLOTS = 7;

export const nearMapIntegrations = {
  Montgomery: true,
};

export const mapType = {
  GOOGLE: 'google',
  BING: 'bing',
  ARCGIS: 'arcgis',
  GIS: 'gis',
  NEARMAP: 'nearmap',
  PICT: 'pict',
  CYCLO: 'cyclomedia',
  CIDEFAULT: 'ciDefault',
  AZURE: 'azure',
};

export const MAX_RECORDS = 35;
export const TOP_RECORDS = 20;

export const moduleTheme = {
  2: {
    label: 'BI',
    color: '#333333',
  },
  3: {
    label: 'AN',
    color: '#4B4BF9',
  },
  4: {
    label: 'MR',
    color: '#F05223',
  },
  5: {
    label: 'EQ',
    color: '#00C3FF',
  },
  9: {
    label: 'AD',
    color: '#71C7CF',
  },
  13: {
    label: 'AP',
    color: '#BDD531',
  },
  14: {
    label: 'AD',
    color: '#71C7CF',
  },
};

export const calculateOptions = {
  MANUAL: 'manual',
  STEPWISE: 'stepwise',
};

export const selectionStatus = {
  READY: 'ready',
  DONE: 'done',
};

export const viewType = {
  CHARACTERISTICS: 'characteristics',
  NOI: 'noi',
};

export const zillowComps = [
  {
    title: 'Street',
    keys: ['address', 'street'],
  },
  {
    title: 'City',
    keys: ['address', 'city'],
  },
  {
    title: 'State',
    keys: ['address', 'state'],
  },
  {
    title: 'Zip Code',
    keys: ['address', 'zipcode'],
  },
  {
    title: 'zEstimate',
    keys: ['zestimate', 'amount', '#text'],
    isNumber: true,
  },
  {
    title: 'Tax Assessment',
    keys: ['taxAssessment'],
    isNumber: true,
  },
  {
    title: 'Tax Year',
    keys: ['taxAssessmentYear'],
  },
  {
    title: 'Bedrooms',
    keys: ['bedrooms'],
    isNumber: true,
  },
  {
    title: 'Bathrooms',
    keys: ['bathrooms'],
    isNumber: true,
  },
  {
    title: 'Finished Sqft',
    keys: ['finishedSqFt'],
    isNumber: true,
  },
  {
    title: 'Total Rooms',
    keys: ['totalRooms'],
    isNumber: true,
  },
  {
    title: 'Year Built',
    keys: ['yearBuilt'],
  },
  {
    title: 'lotSizeSqft',
    keys: ['lotSizeSqFt'],
    isNumber: true,
  },
  {
    title: 'Rent Estimate',
    keys: ['rentzestimate', 'amount', '#text'],
    isNumber: true,
  },
  {
    title: 'Comparables',
    keys: ['links', 'comparables'],
    isLink: true,
  },
  {
    title: 'Graph',
    keys: ['links', 'graphsanddata'],
    isLink: true,
  },
  {
    title: 'Home Detail',
    keys: ['links', 'homedetails'],
    isLink: true,
  },
  {
    title: 'Map',
    keys: ['links', 'mapthishome'],
    isLink: true,
  },
  {
    title: 'Local Real Estate Name',
    keys: ['localRealEstate', 'region', '@name'],
  },
  {
    title: 'Local Real Estate Type',
    keys: ['localRealEstate', 'region', '@type'],
  },
  {
    title: 'Local Real Estate forSale',
    keys: ['localRealEstate', 'region', 'links', 'forSale'],
    isLink: true,
  },
  {
    title: 'Local Real Estate forSaleByOwner',
    keys: ['localRealEstate', 'region', 'links', 'forSaleByOwner'],
    isLink: true,
  },
  {
    title: 'Local Real Estate overview',
    keys: ['localRealEstate', 'region', 'links', 'overview'],
    isLink: true,
  },
];

export const timeLinesData = [
  {
    label: 'THIS WEEK',
    labelForMobile: '<1 W',
    value: 'thisWeek',
  },
  {
    label: 'NEXT WEEK',
    labelForMobile: '>1 W',
    value: 'nextWeek',
  },
  {
    label: 'IN 3 WEEKS',
    labelForMobile: '<3 W',
    value: 'in3Weeks',
  },
  {
    label: 'IN 4 WEEKS',
    labelForMobile: '<4 W',
    value: 'in1Month',
  },
  {
    label: '>= 5 WEEKS',
    labelForMobile: '>5 W',
    value: 'gt1Month',
  },
  {
    label: 'ALL ',
    labelForMobile: 'ALL',
    value: 'all',
  },
];

export const IDLE_TIME = 120; // 120 mins, 2 hours

export const RIGHTS = {
  MRA: {
    MODEL: 'mraEditModels',
  },
  EQUITYFINDER: {
    PROPERTY: 'EquiFinderEditProperty',
    APPSETTINGS: 'EquiFinderMaintainAppSettings',
    DATAIMPORT: 'EquiFinderMaintainDataImports',
  },
  EVENTS: {
    EVENT: 'EventsEditEvent',
    DELETEEVENT: 'EventsDelete',
    APPSETTINGS: 'EventsEventAdministration',
  },
  APPRAISAL: {
    SITENABLE: 'AppraisalSITEnable',
  },
  APPEAL: {
    RELOADVALUES: 'AppealReloadValues',
  },
};

export const gaugeColor = {
  red: '#d32f2f',
  yellow: '#fed45b',
  green: '#4caf50',
  orange: '#f57c00',
};

export const userTypes = {
  PRIVATE: 'private',
  INTERNAL: 'internal',
  PUBLIC: 'public',
};

export const TemplateTypes = {
  REPORT: 'report',
  MAP: 'map',
  GLOBAL: 'global',
};

export const TemplateReportName = {
  COVERCOST: 'cover-cost',
  COVERINCOME: 'cover-income',
  COVERRECONCILED: 'cover-reconciled',
  COST: 'cost',
  INCOME: 'income',
  RECONCILED: 'reconciled',
};

export const TemplateMapName = {
  GOOGLECOST: 'google-cost',
  GOOGLEINCOME: 'google-income',
  GOOGLERECONCILED: 'google-reconciled',
  BINGCOST: 'bing-cost',
  BINGINCOME: 'bing-income',
  BINGRECONCILED: 'bing-reconciled',
};

export const appraisalMethods = ['Cost', 'Income', 'Reconciled'];

export const layouts = [
  {
    id: '0',
    layout: ['100%'],
  },
  {
    id: '1',
    layout: ['50%', '50%'],
  },
  {
    id: '2',
    layout: ['33.33%', '33.33%', '33.33%'],
  },
  {
    id: '3',
    layout: ['25%', '25%', '25%', '25%'],
  },
  {
    id: '4',
    layout: ['66%', '33%'],
  },
  {
    id: '5',
    layout: ['33%', '66%'],
  },
  {
    id: '6',
    layout: ['25%', '75%'],
  },
  {
    id: '7',
    layout: ['75%', '25%'],
  },
  {
    id: '8',
    layout: ['50%', '25%', '25%'],
  },
  {
    id: '9',
    layout: ['25%', '25%', '50%'],
  },
  {
    id: '10',
    layout: ['25%', '100%', '25%'],
  },
];

export const widgets = [
  {
    category: 'Property Widgets',
    widgets: [
      {
        id: 'widget-id-1',
        title: 'Widget 1',
      },
      {
        id: 'widget-id-2',
        title: 'Widget 2',
      },
      {
        id: 'widget-id-3',
        title: 'Widget 3',
      },
    ],
  },
  {
    category: 'Owner Widgets',
    widgets: [
      {
        id: 'widget-id-4',
        title: 'Widget 4',
      },
      {
        id: 'widget-id-5',
        title: 'Widget 5',
      },
      {
        id: 'widget-id-6',
        title: 'Widget 6',
      },
    ],
  },
  {
    category: 'Improvement Widgets',
    widgets: [
      {
        id: 'widget-id-7',
        title: 'Widget 7',
      },
      {
        id: 'widget-id-8',
        title: 'Widget 8',
      },
      {
        id: 'widget-id-9',
        title: 'Widget 9',
      },
    ],
  },
];

export const VariableTypes = [
  {
    value: 'string',
    label: 'String',
  },
  {
    value: 'int',
    label: 'Int',
  },
  {
    value: 'numeric',
    label: 'Numeric',
  },
  {
    value: 'boolean',
    label: 'Boolean',
  },
  {
    value: 'bit',
    label: 'Bit',
  },
  {
    value: 'text',
    label: 'Text',
  },
];

export const initialFilterValues = {
  email: '',
  fullName: '',
  products: [],
  userRoles: [],
  validated: 'Yes',
  status: '',
  userState: 'active',
  taxingUnits: [],
  companyName: '',
  contactName: '',
  agentID: '',
  agentOnly: 'No',
};

export const icons = {
  groupExpanded:
    '<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxyZWN0IHN0cm9rZS1vcGFjaXR5PSIuNSIgc3Ryb2tlPSIjMDAwIiB4PSIxLjUiIHk9IjEuNSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgcng9IjEiLz48cGF0aCBmaWxsPSIjMDAwIiBkPSJNOSA1djJIM1Y1eiIvPjwvZz48L3N2Zz4=" />',
  groupContracted:
    '<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxyZWN0IHN0cm9rZS1vcGFjaXR5PSIuNSIgc3Ryb2tlPSIjMDAwIiB4PSIxLjUiIHk9IjEuNSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgcng9IjEiLz48cGF0aCBmaWxsPSIjMDAwIiBkPSJNNSAzaDJ2Nkg1eiIvPjxwYXRoIGZpbGw9IiMwMDAiIGQ9Ik05IDV2MkgzVjV6Ii8+PC9nPjwvc3ZnPg==" />',
};

export const websockets = {
  event: {
    JOIN: 'JOIN', // An application subscribes to a room
    LEAVE: 'LEAVE', // An application unsubscribes from a room
    TASK_UPDATED: 'TASK_UPDATED', // An async task (like a celery job) has an update
    TASK_CREATED: 'TASK_CREATED', // An async task (like a celery job) has been created
  },
  taskStatus: {
    STARTED: 'STARTED',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
  },
};

export const credentials = {
  dev: {
    urls: {
      api: 'https://dev-container.trueprodigyapi.com',
      authApi: 'https://dev-container.trueprodigyapi.com',
      portalUI: 'https://dev.trueprodigy-portal.com',
      publicPortalUI: 'https://dev.trueprodigy-publicportal.com',
      recalcApi: 'https://dev-container.trueprodigyapi.com',
      appealApi: 'https://dev-container.trueprodigyapi.com',
      deedApi: 'https://dev-container.trueprodigyapi.com',
      appraisalNoticeApi: 'https://dev-container.trueprodigyapi.com',
    },
    service: {
      appealsService: 'https://dev-container.trueprodigyapi.com',
      publicService: 'https://dev-container.trueprodigyapi.com',
      userService: 'https://dev-container.trueprodigyapi.com',
      taxingUnitService: 'https://dev-container.trueprodigyapi.com',
      taxTransparencyService: 'https://dev-container.trueprodigyapi.com',
      recalculationService: 'https://dev-container.trueprodigyapi.com',
      sketchService: 'https://dev-container.trueprodigyapi.com',
      appraisalService: 'https://dev-container.trueprodigyapi.com',
      importService: 'https://dev-container.trueprodigyapi.com',
      assessmentService: 'https://dev-container.trueprodigyapi.com',
      equityfinderService: 'https://dev-container.trueprodigyapi.com',
      eventService: 'https://dev-container.trueprodigyapi.com',
      gamaService: 'https://dev-container.trueprodigyapi.com',
      hsAuditService: 'https://dev-container.trueprodigyapi.com',
      litigationService: 'https://dev-container.trueprodigyapi.com',
      mraService: 'https://dev-container.trueprodigyapi.com',
      appraisalNoticeService: 'https://dev-container.trueprodigyapi.com',
      reportService: 'https://dev-container.trueprodigyapi.com',
      s3Service: 'https://dev-container.trueprodigyapi.com',
      deedService: 'https://dev-container.trueprodigyapi.com',
      queueService: 'https://dev-container.trueprodigyapi.com',
      integrityService: 'https://dev-container.trueprodigyapi.com',
      mobileService: 'https://dev-container.trueprodigyapi.com',
      ptdService: 'https://dev-container.trueprodigyapi.com',
      exportService: 'https://dev-container.trueprodigyapi.com',
      microsoftService: 'https://dev-container.trueprodigyapi.com',
      virtualHelpService: 'https://dev-container.trueprodigyapi.com',
      conferenceService: 'https://dev-container.trueprodigyapi.com',
    },
    keys: {
      azureFunctionKey:
        'bAWG1wJbIdpX4UcyTRETAGFtc9bM8boKGPYR8xwOqLBuAzFuyQaMog==',
      azureClientId: 'f49b317a-433b-405b-b3b1-6a1ade28973e',
      bingMapAPIKey:
        'Ah3c3A46iwqv67dBO18-f_ISQ6odqWflUbqufkJKVo-ng0XvNvqVXBkG9PgiG8JB',
      googleMapAPIKey: 'AIzaSyBp6isPFklaKsVCDZmj4-7umOKerc3K_HY',
      googleMapStaticAPIKey: 'AIzaSyBp6isPFklaKsVCDZmj4-7umOKerc3K_HY',
      trueprodigypictometryAPIKey: '459CFD4D43A8F62E79D2FBBD590B754C',
      trueprodigypictometryAPISecret:
        'FC2C15A6B328415DB3E43331A21F965178EEAF9069D34F4062C98434EF8601B7D3ADA25829F72064BE514BDAF0261CD141F854B8FAFB03A17F01393D144DBFCE869FAC8C98E41A905A1A91B2276EF3900F4B115BB1562C2F8210183C8B560E08C1BA84670C6FA676D80AEB9956AD243177CCEE880AC907F6365070D8F2D74527',
      collinpictometryAPIKey: 'C497685E88AFFE2618AE4E6110272BFC',
      collinpictometryAPISecret:
        'ABDBCF162A076AB955A5B6A165FEC5AD77F1BD7E8456F17559B54F3E0BA9EAFDF8D82276C5FA2A54CE07F2836DEBD5D188FCFD00429345858F5A57ED7B3E832F9F9382A045480C0610FFD3BE480A2A31D2E81D93F5DD9EC081CD5F09DD35877C2623FFF994A12FE048DF266A4A59AA47091B68CE6B9A9750C55CD6A2489F0BFB',
      dentonpictometryAPIKey: '7973B87421A963C1960B6431561C29D8',
      dentonpictometryAPISecret:
        '70DA5C7E69ED1976265A807C1D13D30CACBDF9B38FBCA84A4A2B28C66642137F4A8AFF456A51634304A1E58AB6AA785C03673358EF1B342AD3A9600ED7C3263D8403DF3DFB6D1EAEEC11C1630E3C9909E1D5A5EA0F55744C56601B93533B79948D65CB6B5F9F8CD7CD864305C7E13845078D3F961DC73AEFC1353FF43F4E40DD',
      potterrandallpictometryOfficeAPIKey: '836498083D39E1572845663BB4F6AD03',
      potterrandallpictometryOfficeAPISecret:
        '01DA9D1FC68BEDBC2B3E9832836716F89B97AFED4B582A964C7606812EC58ABE8DF303C033482B87B2F2CEAFFE0810EE7015D9EECC57088C775FEDE9E8731F12634FB1C4FE480BEA100ABC2970BFD211961722716339AA6F556B93EA281677624A96E8CBDF3E629F83CCB116931CDA6EBFBF194D2F4498DE101E6B699A3F0316',
      potterrandallpictometryAPIKey: '9AC99F69DEE1E4394D0CD8C39444F80E',
      potterrandallpictometryAPISecret:
        '365CB6B3FD99D36A509DC21DE3DAF8B6029142C1768472A9B68A5D0552BFD0AD9FFF178A52DA8A5855B9C58AACEEAB0E55057E9B50446C2A7B004E8F388A4BD7E4040C8678898FE2EBF2CA785672E1D5760F21A42066095A37380467E15B518A502B92A853A0DB6329E26F8CA1A1FB5D37B5DC83C8C1886232F3E1756F8B693F',
      valverdepictometryOfficeAPIKey: '57B0A05D8D05E4D1E58A7DC2F1D9A43C',
      valverdepictometryOfficeAPISecret:
        'B3B092DB53F279FE6A8730B0A7FE93C0795D56A3842BF6103C0D7EA58C8604DED051E03C299320C590FC72431EC6476DBB7645F3E8E0620C8F365F3488DB4637D56A7B3E7247B5740CB78D06CE4B7E5219E53C284D2A290F026E539F89BBC38753CCC7346D8C87739698FFDE31F19880C3BF70BFE1BAC80AAF62F79CF9FC48CA',
      valverdepictometryAPIKey: '61EA91AB751EA97F11B3C0906989E609',
      valverdepictometryAPISecret:
        'A1431ECD5D2C4074D2DBAAE51D3F6BD54D91D8AFBBCDCC3C61C7898166F72AA9FB4504C1A043DF60CBFB97E35C751FD45AF4E017CB646E19C8FDEA83F01B819C24BD1E2DE21F348F3CB18E2B7C5D6D6599C917BD1D082D715F7F5CF4F77234B0BC7F01450A407372F73730F53BE9EE9E90A851C1DEBBBB6EA5476CD808102279',
      travispictometryAPIKey: '459CFD4D43A8F62E79D2FBBD590B754C',
      travispictometryAPISecret:
        'FC2C15A6B328415DB3E43331A21F965178EEAF9069D34F4062C98434EF8601B7D3ADA25829F72064BE514BDAF0261CD141F854B8FAFB03A17F01393D144DBFCE869FAC8C98E41A905A1A91B2276EF3900F4B115BB1562C2F8210183C8B560E08C1BA84670C6FA676D80AEB9956AD243177CCEE880AC907F6365070D8F2D74527',
      travispictometryOfficeAPIKey: 'A5EFEB6038B1046937C5E2759C7B60F5',
      travispictometryOfficeAPISecret:
        '9953A37A7220E23E6E65F57C3E84DF50A260939AEDE3D8C663CAE8E23003237D14A0D4647D077DD2D673EF1A8777AD0062838A1DB9510499A44F49C9FDD1C18B23FF8226AA88B66A4825F0FBF8748C27F53E45B746BB794C988D3CBB8738263AFA2A06DD57D4BF2C38C918603393A5843DF7A052A2EEB8CA3E3B529A82FA5D7C',
      clientID: 'ee55134e-1e6a-4ceb-bc24-1537d75a6d76',
      ellispictometryAPIKey: '22E5CDA115310D1E5EE5D68C49B175FC',
      ellispictometryAPISecret:
        '5A5D40CF1E8C5DD63EDD6430E32403878B4DA95624D67903901EAF3773476176C3676D7FDD80F1B279E69647048A78803A21BFBD5A00A89E7E5B3E5608C89B2EDEB62BE63B780FABE028D7D62C2A9B8724D4305037C29477D340D45B0AAC05549C68A131BFD0528009ED0C725F4332EBE0E348B94E10569FA7CA7B06E61DCE25',
      ellispictometryOfficeAPIKey: '28DE25D3EA502E27BE1072E0AEB79056',
      ellispictometryOfficeAPISecret:
        '8C190F1ED9E2B4CBDDC500CCA47C852CFE95958FE106B6E497A3134102AC06DFDBFDB2A991FC18E058BFD9E8003A48C501A8A3A61E9979D639BCB8E2F1901B4BAAEF487A27DA5C338D7042AAC11575DB311A16BEA1932976A17DE712F83A9A7C1F4CC817A4E4D66D1EC8012048864A57469EEDA78528B48D484403C6C1660372',
      webbpictometryAPIKey: '20E09C60A06FDA1E01D70112BE367B05',
      webbpictometryAPISecret:
        'EDBFF31D8DDD63190AE312064929D9CCE34DDB2754C37B61E1B72840126DB7C606006F428A9873D9D83F30503C02D3D87B3282B9CA853F1D479D69FCF642B0E38C52DB4AE0CBFD7E13F7B533C4C3E1693B850360BB228110C15CAD5A9D075F2F6B2E83083E7AA9EFBDBCAF86A88E73A4145BC5FDB096558A5363F85DBB9A4514',
      webbpictometryOfficeAPIKey: 'C1C453FC1EA86A2E0320DF97E0D4E8ED',
      webbpictometryOfficeAPISecret:
        '88A28AAD6EE5A9D4495819C5931DFE740D3C89FAD5CE9FB1FF38B0C0EFB61A2CC26539EBEBDE94EAB2986ADD0B352DE2976D6480A06C311B796D59DCF68CDDBE34117ABFEB716527818F7CB3A3EF0E8D037B142D0523F5D94243B6A5BF29AB38AFD63244C4544D32AE0B5EE68C2B3168A9472A6C90B174FBEEB63698C682D814',
      maverickpictometryAPIKey: '250DBE85A228E17BBAC5BE160A87C4E4',
      maverickpictometryAPISecret:
        '5B6654DD85E924A9F375BCA3BE7F22D8B110F0F61804750D661C11A3F4751C5BA4ED69F24E17C4C348802DFD81A22B06D0AC21EE6B5DABAB6A74E8560E7ECE34800FF8FB2AE9545E171074518543B6F7F49672200A2C6598D8EE3C84617C1EFCB0E836D2B0303B186FB5B8E1C0FC9CBA7DA416DB6FFB50FE16EE95F91D9BB866',
      maverickpictometryOfficeAPIKey: '31E9C4BAAF376D6193C8334172BE7E6B',
      maverickpictometryOfficeAPISecret:
        '5E1252CD39D4E98879DF13448EA79ECC247BD5AE8FD3FF9281DB582900DF99D2E1AC191C0CF0CE0DAC9ED77E8D261293E7B97B8B02702E2D8EFC47D5BA3DD624DAB13AD3306E4DBBCA9C7AA50115A7021839227875E3F92693D311C038A4038A31FBEF4558D40D89EE41B5FD548500159E9460B1905927203D54E8271C65BA06',
      rockwallpictometryAPIKey: 'DEEB55F45DCC6CC04A5B49FB7C668B95',
      rockwallpictometryAPISecret:
        '557101313E2128F80A478AD936ABDDE955E789DF7F131390267D711864DF09CC600C1B2222F3A979CCD7311ADB081417285B26ACE101002D4A5B7B0E7DEC6A5D053E0320FF75D6D7063FED150EA8CDEA90CB05494ADBD35F84CF05687F0AF0D0DB21BE766959BC257A5476DB829775E3FC989E8F712C2ACBAD4352A0D44B3B40',
      rockwallpictometryOfficeAPIKey: '4E716B538FB3E6617D7814BA791FE059',
      rockwallpictometryOfficeAPISecret:
        'C5FC69CE8DA89418F00423396D52AE5C8D453062CC49F775195A92EB8317088138CFE83D6E40751CE1BE537A67EF75D6C468D2A52D77F115A34F6E7E3237A3817268508FC243D3E18D0AE03F078D6BCBFAF1B7B48CF90FAEE3B56D49F24249EF023537ED17A49982B3DA86FFD7D2B3597D4A59EE95F94449F0A73A57A73F7B64',
      cameronpictometryAPIKey: '009A52659C0B12FEB54579FF9407467C',
      cameronpictometryAPISecret:
        '2E005EA1ED0344C848FBE09C36B330992FD8C5AD259439D2E8203F17947656B12B0897F94DEA358A341708982F6E1D6941DE040E79FCB36E8AF94D714241326B21F6ABFA4DCF7631F1D9F3340CFEB3945A71E6651D3B998A6FFEF1461D01652FC0B45612F30ABE0C4D3B3FF1151213474696B6B345996F430C60990905ABB4B3',
      cameronpictometryOfficeAPIKey: 'B6E23A1E2CA3367B6638FA2463F17C8E',
      cameronpictometryOfficeAPISecret:
        'A26701505F0D53224D3DAF3F877E2ED90164DB4678855FD39F9420B7799FE059884A74E88BA366E1BD2445F94818050472E64A8AA9B109F8A1D1343416613AB8E417953DB0C8F776F5C3A29F3CF07DF3D0FA33D3E85254B512954A758622630F4A5C490778025A70570910E37E67F712CDBB207A80156C56B68408A9F07DF218',
      reevespictometryAPIKey: '064FA280B3A2847A53B8369E350606AE',
      reevespictometryAPISecret:
        '2491AA0B28D624302CA1D0CE2AAA42721A4FBA420419FFD9033B2C6740845E9A6C8C0E221E07448868F50171021B7A212BA21D21A3724A5942BE207716828496CBB882A9F8B9E51B59F42C0E2D1B4F38C0738008088CA79B519EA4A34F978E3B49A78B324AB967F4DEAC39C3E33FE81B9B7E38DA9CB10B7A4362D50FEB1031E2',
      reevespictometryOfficeAPIKey: '5A9C69B5AB8CB59E6D1D5E9D9F2CECF2',
      reevespictometryOfficeAPISecret:
        'B284D7A1A9DD1365EE078379BA1B0ED390C559634DD7F87993A44C41C358EBF8688981DBDF14B0F1528D8837B59D61B53D7D15C14C68E38859026ADF08A7B9321F91BA71570A0FF4E39FB90CE13C8D8712C56A04BC10035C65F9E543C0084C9F67E39D19F53AB2A7A17832125DBE71C488E02955995F0AA116D81143DBD7EE65',
      cookepictometryAPIKey: 'D52BB787445212FCF135C4489CF312B2',
      cookepictometryAPISecret:
        'F3521795E257B684C004CC43038786516D80A57A6CDF8E7582C1AE253207FE4EFDFA3E2655604C57B68BE023CC926EB34C40DCE9990597CAB0790F74C09D865306743EE7B99D605628FFD9DB606027D3A55720477CDF2CBFC19BBE8B4F226F87183A103BB0834521AE6D6F40F3220ED2DB99CB83FB99C7490094EC21BCBCBEDE',
      hidalgopictometryAPIKey: '2E9A0B5354B6C40778ECFDC44CB9F08B',
      hidalgopictometryAPISecret:
        '8CF5E246054CEFF54D6847CB6C0DC2A765D2D3C0575CBFF0C02603D30BA0016D6D83CCEB8ABE7AF949870AC39F646A4CADF7F31BDA0E683B2E6AF02A346DFEB00FB8CF1AE80C81A3D5EC3E17F01E3C8C62991B8B00AC5233F71649B9747A176F293F1E2EC42300D7934F3F899A8F7904C20F57E2C1AA8AB65577926C23293DAD',
      tarrantpictometryAPIKey: 'D29A4BA38348754F20CA5AF3A1913574',
      tarrantpictometryAPISecret:
        '8A8DBDE7FBB396387A6201E2C601D3F1FFAA673CEC0DB68BAD689FB0B140A35AE062C35FEF083964DC301BDA63786ABC09C3B2BB293B06AA131A2FA8DC7A32225E74E0FA2108FFDAC98ED4A4A68E7EF185784139C3221F4208637A3FF36BFFF97EC1F3FC1D2A05D4EBEDDDE16D4FE276B4F700508A7050BE4E229DC29F2543CB',
      montgomerypictometryAPIKey: '06B8E2C1A9992182635141DA5CF32815',
      montgomerypictometryAPISecret:
        'E35EF2BEC394C07169DF56231559E04AB9397414D7751AE944CEBAF4A5F9EFBAC844B785736FFE9EBE8CBEB55E57593CB8F3AA0DEDC4FD4E050628792AA6CE16A648010922CC9189E28710B34641D843533373FB22528C94595A71AB221EA578D38F583A00CF85799DFC31B09CFE373521668229754FFD068B41C493F98852BC',
    },
  },
  local: {
    urls: {
      api: 'https://dev-container.trueprodigyapi.com',
      authApi: 'https://dev-container.trueprodigyapi.com',
      portalUI: 'https://dev.trueprodigy-portal.com',
      publicPortalUI: 'https://dev.trueprodigy-publicportal.com',
      recalcApi: 'https://dev-container.trueprodigyapi.com',
      appealApi: 'https://dev-container.trueprodigyapi.com',
      deedApi: 'https://dev-container.trueprodigyapi.com',
      appraisalNoticeApi: 'https://dev-container.trueprodigyapi.com',
    },
    service: {
      appealsService: 'https://dev-container.trueprodigyapi.com',
      appraisalNoticeService: 'https://dev-container.trueprodigyapi.com',
      appraisalService: 'https://dev-container.trueprodigyapi.com',
      assessmentService: 'https://dev-container.trueprodigyapi.com',
      conferenceService: 'https://dev-container.trueprodigyapi.com',
      deedService: 'https://dev-container.trueprodigyapi.com',
      equityfinderService: 'https://dev-container.trueprodigyapi.com',
      eventService: 'https://dev-container.trueprodigyapi.com',
      exportService: 'https://dev-container.trueprodigyapi.com',
      gamaService: 'https://dev-container.trueprodigyapi.com',
      hsAuditService: 'https://dev-container.trueprodigyapi.com',
      // hsAuditService: 'http://localhost:5037',
      importService: 'https://dev-container.trueprodigyapi.com',
      integrityService: 'https://dev-container.trueprodigyapi.com',
      litigationService: 'https://dev-container.trueprodigyapi.com',
      microsoftService: 'https://dev-container.trueprodigyapi.com',
      mobileService: 'https://dev-container.trueprodigyapi.com',
      mraService: 'https://dev-container.trueprodigyapi.com',
      ptdService: 'https://dev-container.trueprodigyapi.com',
      publicService: 'https://dev-container.trueprodigyapi.com',
      // publicService: 'http://localhost:5026',
      queueService: 'https://dev-container.trueprodigyapi.com',
      recalculationService: 'https://dev-container.trueprodigyapi.com',
      reportService: 'https://dev-container.trueprodigyapi.com',
      s3Service: 'https://dev-container.trueprodigyapi.com',
      sketchService: 'https://dev-container.trueprodigyapi.com',
      taxTransparencyService: 'https://dev-container.trueprodigyapi.com',
      taxingUnitService: 'https://dev-container.trueprodigyapi.com',
      userService: 'https://dev-container.trueprodigyapi.com',
      // userService: 'http://localhost:5017',
      virtualHelpService: 'https://dev-container.trueprodigyapi.com',
    },
    keys: {
      azureFunctionKey:
        'bAWG1wJbIdpX4UcyTRETAGFtc9bM8boKGPYR8xwOqLBuAzFuyQaMog==',
      azureClientId: 'f49b317a-433b-405b-b3b1-6a1ade28973e',
      bingMapAPIKey:
        'Ah3c3A46iwqv67dBO18-f_ISQ6odqWflUbqufkJKVo-ng0XvNvqVXBkG9PgiG8JB',
      googleMapAPIKey: 'AIzaSyBp6isPFklaKsVCDZmj4-7umOKerc3K_HY',
      googleMapStaticAPIKey: 'AIzaSyBp6isPFklaKsVCDZmj4-7umOKerc3K_HY',
      trueprodigypictometryAPIKey: '238CDED32C01460CC08627368595EADA',
      trueprodigypictometryAPISecret:
        '338C0A308D15A01F206F7E770A1AD65958AC31B6EBD6AA3F8FE059CE11291CB4A6A6DCF994FA805FA604DC215BE76411532514F5F540AB51209922AFFCCC9616CE0A4BDF6238CB9FBB691A38168F88A145C6C5C949138EA181BC6EF92DB851BAAF5E762BDD5E3E7DAC8E658913961C24D1958FEC615253324F72EA18BBC6B3D6',
      dentonpictometryAPIKey: 'EC226E984B72B94D2E2C83D5997CDBEE',
      dentonpictometryAPISecret:
        '5EFD6FDA3319A65CA8BEB60B77C9BA7B79D34760E7EC84E122AA52331EE9BAAF4BEBE3701D6AEB66CC1732754A96603160024BB9328DC1C261DD233CB8FD8B5B88A2E8723C234E6B6F870F3CC922AFEB096AF4237B82B5CCBB34A915A145EE4F5351A4A40E0DB7F84952E54B2EE1369426DF1EFCDE95773BF419179B365BAAE1',
      webbpictometryAPIKey: 'EC226E984B72B94D2E2C83D5997CDBEE',
      webbpictometryAPISecret:
        '5EFD6FDA3319A65CA8BEB60B77C9BA7B79D34760E7EC84E122AA52331EE9BAAF4BEBE3701D6AEB66CC1732754A96603160024BB9328DC1C261DD233CB8FD8B5B88A2E8723C234E6B6F870F3CC922AFEB096AF4237B82B5CCBB34A915A145EE4F5351A4A40E0DB7F84952E54B2EE1369426DF1EFCDE95773BF419179B365BAAE1',
      potterrandallpictometryAPIKey: 'EC226E984B72B94D2E2C83D5997CDBEE',
      potterrandallpictometryAPISecret:
        '5EFD6FDA3319A65CA8BEB60B77C9BA7B79D34760E7EC84E122AA52331EE9BAAF4BEBE3701D6AEB66CC1732754A96603160024BB9328DC1C261DD233CB8FD8B5B88A2E8723C234E6B6F870F3CC922AFEB096AF4237B82B5CCBB34A915A145EE4F5351A4A40E0DB7F84952E54B2EE1369426DF1EFCDE95773BF419179B365BAAE1',
      travispictometryAPIKey: 'EC226E984B72B94D2E2C83D5997CDBEE',
      travispictometryAPISecret:
        '5EFD6FDA3319A65CA8BEB60B77C9BA7B79D34760E7EC84E122AA52331EE9BAAF4BEBE3701D6AEB66CC1732754A96603160024BB9328DC1C261DD233CB8FD8B5B88A2E8723C234E6B6F870F3CC922AFEB096AF4237B82B5CCBB34A915A145EE4F5351A4A40E0DB7F84952E54B2EE1369426DF1EFCDE95773BF419179B365BAAE1',
      ellispictometryAPIKey: 'EC226E984B72B94D2E2C83D5997CDBEE',
      ellispictometryAPISecret:
        '5EFD6FDA3319A65CA8BEB60B77C9BA7B79D34760E7EC84E122AA52331EE9BAAF4BEBE3701D6AEB66CC1732754A96603160024BB9328DC1C261DD233CB8FD8B5B88A2E8723C234E6B6F870F3CC922AFEB096AF4237B82B5CCBB34A915A145EE4F5351A4A40E0DB7F84952E54B2EE1369426DF1EFCDE95773BF419179B365BAAE1',
      collinpictometryAPIKey: 'EC226E984B72B94D2E2C83D5997CDBEE',
      collinpictometryAPISecret:
        '5EFD6FDA3319A65CA8BEB60B77C9BA7B79D34760E7EC84E122AA52331EE9BAAF4BEBE3701D6AEB66CC1732754A96603160024BB9328DC1C261DD233CB8FD8B5B88A2E8723C234E6B6F870F3CC922AFEB096AF4237B82B5CCBB34A915A145EE4F5351A4A40E0DB7F84952E54B2EE1369426DF1EFCDE95773BF419179B365BAAE1',
      clientID: 'ee55134e-1e6a-4ceb-bc24-1537d75a6d76',
    },
  },
  stage: {
    urls: {
      api: 'https://stage-container.trueprodigyapi.com',
      authApi: 'https://stage-container.trueprodigyapi.com',
      portalUI: 'https://stage.trueprodigy-portal.com',
      publicPortalUI: 'https://stage.trueprodigy-publicportal.com',
      recalcApi: 'https://stage-container.trueprodigyapi.com',
      appealApi: 'https://stage-container.trueprodigyapi.com',
      deedApi: 'https://stage-container.trueprodigyapi.com',
      appraisalNoticeApi: 'https://stage-container.trueprodigyapi.com',
    },
    service: {
      appealsService: 'https://stage-container.trueprodigyapi.com',
      publicService: 'https://stage-container.trueprodigyapi.com',
      userService: 'https://stage-container.trueprodigyapi.com',
      taxingUnitService: 'https://stage-container.trueprodigyapi.com',
      taxTransparencyService: 'https://stage-container.trueprodigyapi.com',
      recalculationService: 'https://stage-container.trueprodigyapi.com',
      sketchService: 'https://stage-container.trueprodigyapi.com',
      appraisalService: 'https://stage-container.trueprodigyapi.com',
      importService: 'https://stage-container.trueprodigyapi.com',
      appraisalServicePerOffice: {},
      assessmentService: 'https://stage-container.trueprodigyapi.com',
      equityfinderService: 'https://stage-container.trueprodigyapi.com',
      eventService: 'https://stage-container.trueprodigyapi.com',
      gamaService: 'https://stage-container.trueprodigyapi.com',
      hsAuditService: 'https://stage-container.trueprodigyapi.com',
      litigationService: 'https://stage-container.trueprodigyapi.com',
      mraService: 'https://stage-container.trueprodigyapi.com',
      appraisalNoticeService: 'https://stage-container.trueprodigyapi.com',
      reportService: 'https://stage-container.trueprodigyapi.com',
      s3Service: 'https://stage-container.trueprodigyapi.com',
      deedService: 'https://stage-container.trueprodigyapi.com',
      queueService: 'https://stage-container.trueprodigyapi.com',
      integrityService: 'https://stage-container.trueprodigyapi.com',
      mobileService: 'https://stage-container.trueprodigyapi.com',
      ptdService: 'https://stage-container.trueprodigyapi.com',
      exportService: 'https://stage-container.trueprodigyapi.com',
      microsoftService: 'https://stage-container.trueprodigyapi.com',
      virtualHelpService: 'https://stage-container.trueprodigyapi.com',
      conferenceService: 'https://stage-container.trueprodigyapi.com',
    },
    keys: {
      azureFunctionKey:
        'bAWG1wJbIdpX4UcyTRETAGFtc9bM8boKGPYR8xwOqLBuAzFuyQaMog==',
      azureClientId: 'f49b317a-433b-405b-b3b1-6a1ade28973e',
      bingMapAPIKey:
        'Ah3c3A46iwqv67dBO18-f_ISQ6odqWflUbqufkJKVo-ng0XvNvqVXBkG9PgiG8JB',
      googleMapAPIKey: 'AIzaSyBp6isPFklaKsVCDZmj4-7umOKerc3K_HY',
      googleMapStaticAPIKey: 'AIzaSyBp6isPFklaKsVCDZmj4-7umOKerc3K_HY',
      trueprodigypictometryAPIKey: '071BA4A8B0C551E740A5DADBC798ED93',
      trueprodigypictometryAPISecret:
        '0BF150FEDE5071703D59584A356825E982E82344DFA3F36059A3C006EAD59ADB1374FD7A7928DFA1FFAFBA549EE1293E59FDEC3EF6B5E6C0617A39A02D9D2AFFAB991E567E33F4FAABEF098ED04A416D7B3CAB83D9213FAFA3A5DE3CC77D600E0E572B7EBBA2749BFAB88D03361BBF3334055BD0CDCF2ED7832F984D26FFC45B',
      dentonpictometryAPIKey: '071BA4A8B0C551E740A5DADBC798ED93',
      dentonpictometryAPISecret:
        '0BF150FEDE5071703D59584A356825E982E82344DFA3F36059A3C006EAD59ADB1374FD7A7928DFA1FFAFBA549EE1293E59FDEC3EF6B5E6C0617A39A02D9D2AFFAB991E567E33F4FAABEF098ED04A416D7B3CAB83D9213FAFA3A5DE3CC77D600E0E572B7EBBA2749BFAB88D03361BBF3334055BD0CDCF2ED7832F984D26FFC45B',
      dentonpictometryOfficeAPIKey: 'E8D026A7665D458D5384F4854A6B2CD0',
      dentonpictometryOfficeAPISecret:
        '48BD9DA6E784E72C9D2E9A2DE707341CAF32415C4CD97BE72E53726BE5BC4D79255E35338519BCF81871CFFE6B9574E744B40771EC8C8B73ECE397AF6A1DB1D5404DEDCD66E6117092DFEEE45924F87AC421728CCC6D7247A3F2EDC8CE89817A0ADA9E1A543C2AB5CF1088AFBCD3D61FD2F2A3DAF04BA49708C1C2E173F4E658',
      webbpictometryAPIKey: '7F10A60080967F7ACBD647848162A4A0',
      webbpictometryAPISecret:
        '184832B55A6A31DD64E1F75C65BF7A051ED0BBE23E56B37A4EBD0ACA3848294967119355D67EC5AB54E2DCBD2E87B9A2E86097676BCBD3E2A1DA34AA288EDBF025A8E1AE92840CAD316A687FE8E737344F4514409A4769F58D69D54B9B5F73D019EF3551D9A9D2D9085136D5D5D7AF1C4E4ACA89AB6A55F94BEC74FA5266B0E3',
      webbpictometryOfficeAPIKey: '0D56DE567AFA64F66EA525400A7F472B',
      webbpictometryOfficeAPISecret:
        'EB4B052123C68D1C15C9BA2F5620D165A7F416C9CF7114062E013C2AF47E708EA452DEAD68EE7A408D416C1DA2591A8B50991AFB447D82F269BA453902BC7B61944499120600511397384CCAA730ADCEA27FFC56A87AED37B06059E0A38F002297640AA03210B0DEE3FDAB8BCF246275D885228B9FEADA1195777DCB2E2924A0',
      collinpictometryAPIKey: '41BE0FAE7E4CA5F861F726B5065BCAFB',
      collinpictometryAPISecret:
        '89BB0BFDA0F12C8D2F790ED7377ACFEE8FEC977F7AAB12C273511B7F4C6F30DA7EA06E420CD57B323FC547C20A3CCE2C4ABE23970FAB7DC760CD5130CEC68DF43F4B29D830BA63A6AD5E05B4E6CBBE8733B7B64AAC483221D6309C2A6DF1BC58EFC780E8D1C634FE393F0299444718E092CD0F3B702703A37A757DF9274C8CB6',
      potterrandallpictometryOfficeAPIKey: 'DE0972A9CCECC87C468047C6046EF951',
      potterrandallpictometryOfficeAPISecret:
        'C5550E108BAEF0F68F4E77B5591F7F40ED640BC546C1AE9F3EEA7A0FA275E08FDDA7DE151E133B394E3EF8F7EC55106985F24323BEC28DAA159179BEDD69A771CE80543B72D072F4C48BC73339AD398201BC697C403B13A5FE7646C297A2DA0015CE601DCDA28BE44DEB78E0FD7CBABE641A3D31729AB44E47DCB1E83A526CC9',
      potterrandallpictometryAPIKey: '944EAE78F9CEEF08E7AD81D9688C56D7',
      potterrandallpictometryAPISecret:
        'B330A78341CFBCEC9771FA4F7223A443CA698B28B3B2F54AA0F38B69EA1CF6FDC4EF99D04AD0AC4332E6C4D2B366CF383428D0A7D473F2DD6661220F0151DA69FAC5AA5BAE8267B8AD610F63B1B1BBAD54C705C42A7BB00B827E41B177170761F6DD53CBDF767A89C5AA0F3DDA4D72E89AAA810CA5F17D0121D52F1DD592FB8C',
      valverdepictometryOfficeAPIKey: 'FDD8C4153DA053CD1650195278688991',
      valverdepictometryOfficeAPISecret:
        '751BADB04C93CAD180EBC15966E386716729A0FA3239E8768F72A16E50AE2997208715797F6232DBE21E8767839BA7E6AC0D3B87C27950E8D2199CF2BED1E88F0588677946B66CA388CCAD7B39CE48DCE39F5BC7F0AEA1716304E0245FD8634EC1ABB5B60050BA991C0C4FD9099A717D6714A537BE616F27672FBB97F16E61E5',
      valverdepictometryAPIKey: 'CC0C058A07EDFC5E5D1EC209F221569D',
      valverdepictometryAPISecret:
        'FCF18145AD68E134C1655607D3DCA0C2C801FD9B5B7DAE31621C69E08D542F963BE75427BD1DAF23DC43D4A4BC41EA326037FC972CED68AF840C326BA4D8AF3753CE4A1F7B03832030BE7FE81FBA9CCACF7C0118F29E1FD559959665B0E95548A4FE3C857AA4574BF1A4E493D561839138EE8AC0A2575D176A985F2E19C99C96',
      travispictometryAPIKey: '6324316A4938006C0126296735267B93',
      travispictometryAPISecret:
        'C94051BB443CB2FA877CCCE659A35316ECF43FCA5D395B593A8B1FDE342C279D98137EA27FBFA61A6545C79F977D07147A8E876AB61CE965EC114C0D012814CFEB783E57C85E41B054745C249DDFE8DCA171CC868758B336483BC349C263B7D3EC68C1D2D1EBAD78CCB37367B22540EB574C834931278DF1125FC6857293AAC6',
      travispictometryOfficeAPIKey: 'AE8D4233F6E00AED02F7262F784DE4E2',
      travispictometryOfficeAPISecret:
        '1FEB71156E1D2D22EAEF30E820949ECA6664EC966B6CAB427DCE4F531D82A74D59720236E955B6644A174B17224A738F566E0938AF0718557884D5E0A7B61D7D9860A752F1DA6F2BE3126AA8518F6F7415AED0B25B4EDFD993F2CE87AC7031DF7F4FBFBC4E980D00DD7A211565C3DA5690BA1EB7BAA0B95E77CA011FF2DCD8D5',
      clientID: 'ee55134e-1e6a-4ceb-bc24-1537d75a6d76',
      ellispictometryAPIKey: '4C7361E2107E161CC4858EA0019FBDCE',
      ellispictometryAPISecret:
        'B32752354C5A42FB1022814B1AD8C57AFF9377EA4FDB22B17F876FE5F38304B28704450D927EF202852E1CA9232E54272E9BBD581F8D77CD3499EB3B5A708D3D699F0EA764B9244E5C7B15537B6B0BB2139B08D4F3F2138CBDFC2CE9F8CFEEF8C92BCC6C709D158704337392DF338E0D76DBE001E938FB535084D0DAF81E8EC0',
      ellispictometryOfficeAPIKey: '365C6B1EEE064C8CBCCCF6DCAB7F5531',
      ellispictometryOfficeAPISecret:
        '3E39FC0CA412343B9CD3CCB60E644C6AFA3EAB1EAB404BB6DFC44DB9502818E5FE2CE98E6B46203360C20982A14738029ECF74AB3727D4A1F67A15BB8EA8BCCE93034DF204B44225B2D955C8AA9C9EF7B01F52CF8D0F653F481A1B7D427A1949F6ED6BB94885C46FAF074F6344FBCEB845D052E69317AA385774A4FAE8C985F0',
      maverickpictometryAPIKey: '44DCF10DDE282ABF1FB9510163D277EF',
      maverickpictometryAPISecret:
        '6BF9283077B1C3C9CACFAC836F85F22698D9EA976A73C4205E5EBB91CA6116E52BB819A9C8D1D5536DEBC86C96142C70D529CA936BB2959A914D18D6F412077E70517B1150CAF9E6F1B1E3169FEA108A370EC76CAC504AC2E05C6A85830C69F834BCB65F0F9F077FA9FDC08047CC206E8D71273EEC2C0901B512747D6EEDC470',
      maverickpictometryOfficeAPIKey: 'CA0144C81C9F64283FCE24FEC40C0DC5',
      maverickpictometryOfficeAPISecret:
        'BC065A97BBBB153EC350F559DD07814206102B203996B018CF82098830209A07C7EAFB41307D30055230233348FF5E472D2982DDE32812E101132C6433A8779B0B4370DACF9D0FE5EB29F9A937374D331D9708F95519C7B25733D7A1790C2929A78DB3C98338A8031CA3CFED19C714841F59B6FD8C21413A6FA16B7C6BAEF589',
      rockwallpictometryAPIKey: '39344D32CED81C05FCF2BC396129F34E',
      rockwallpictometryAPISecret:
        'EF25171AA5978DCCBFB8FFD67B633EF743FA8B62240A12ACA280BDC6427EC9F400C0A56552E179268343F2CDF1F9B3CCBF08B480E9160E7EBDDAB40ECFDF53A16FAEC5C6EABAEAC016B3E9095EE0F19543D969D4BEC9263239EE09F033F602381B37B3789B96C21BAAC790D0938A5F25E2F80450730BAA540678A3057C918D34',
      rockwallpictometryOfficeAPIKey: 'BA8E73DD6ED148E0B9715930C3A262D4',
      rockwallpictometryOfficeAPISecret:
        '28D7BBC7EE99278990666BCA85DD90CC33ADE9403789510DBA07037F514CE322DAD7C754B9759A8C6F94C2044101A0592ABB93C2DBC4DD7654A4994B8793A118D71469A8CE67BF20C6446D6FB3072C9EB39EFEF8F002B803BB9060E980B5AC23D6D702B704353736387FCCB53308B569A6A758FAE4D96259670B143AFF84B97B',
      cameronpictometryAPIKey: '18363BCD6115C8BCEC679139CA638C66',
      cameronpictometryAPISecret:
        'A0AEE795A2A94C52EFB2B55CA041344CABB2EC73C8AFDCA62252FF15CD14FA78C17D9BD6C74B0527E01A9F5464F089BBDA6671AE8E0E59B820711C7353D9AA76B3E312ED263E77B749AD5662F48A18E7FB28D97C21F3C0E70C4D4E0F9A70BD2D50CA083615D2E1929747BB69D09C5CC2A96D12C3A2D7CAF1296B54956B772837',
      cameronpictometryOfficeAPIKey: '128BFEC992560AB68EA91FDF805D0FEC',
      cameronpictometryOfficeAPISecret:
        'CA06DCA8AD487CC4F80CB6C4B5683E293F144450C262DECF2965101E548F6E7FD509402BC70E32D6CCBF7970A9B74C3BA57DA20A20C2C2A85058A56AF5C4EF3E8D1A7B31646A4A2D8FB7D73104B96FAA22C3DAF2973F6F38055A767DFE806D0D025F2B7174D2D81E6F0D89AD34D0794F50D8E3C45901F0344FCE668AA78F728B',
      reevespictometryAPIKey: '10BA6D69FBD38343BB1F910C923EA26F',
      reevespictometryAPISecret:
        'B432ED84B20D7C82843AC0CC98546CA7E37CCF36A49C60CCB7B6924C9269D417010192B607C91301B2E3125EA28BC349F5C100FBA29823867B81E6BA84FD13744E3F35E8ED2A9C9A5227EB3134F1B90945B836BA1FD9C487AE8BBFA8EA32E132DC7629E6B88C1B162A7974CDD3FD1540539AF0BCD05343934331605C9F174E4D',
      reevespictometryOfficeAPIKey: 'A23B1B7E495FE67C0701EC031B2AE1ED',
      reevespictometryOfficeAPISecret:
        'BC41FF1F302A6EA7852FE83EA836BC564E1764A04439F60AE799766DCDD922CCC7E30DEE5A74047AB9C85CBC34FE7C93DE0A8EC713AA9B65790AE7BA8970096C4762F2EB82047DF8876D39FD00C3ADC6157A522F9A133B0A5745A59EF1434DC21AF3ED577C93A73A432F194BA18257A8AE5E9A1F6DCD4D098B35FA37686813E6',
      cookepictometryAPIKey: 'ECF0B9B52D29D6102DEA09253FA49413',
      cookepictometryAPISecret:
        'F9DDDEEDA36C03C2E43375F904E9767FD0B62CE3812A37DDC182D0E25BCD710CB4EA0A29443E55D5A73CE9DE4BF8B541E0D18705DDC060529EC6A9B92D6307446F0B127DCA29296A2EDCB5759E519C0E19D992B793C15D1A67D44FC9E8973AF6B49E8B961FEBE056A2CD7161243F849E5E8BEA020918232FC28E5D75BF1CA61D',
      hidalgopictometryAPIKey: 'B26556F643F110A2C2FAA0991A36E691',
      hidalgopictometryAPISecret:
        'C1998E57779FE46902AF589B8E673CEF0AF3606FBCA8D892038DFE4A5C07CB3A0FFBEFACBF523622F9FAA68E9997657DEA0BE992561DAC0B30DC74AB99D098F03478D0CF28F39F2AC0DC52F82366D149C0E554E250BC585B0AC6C2CF53BFF77F334252A1F1D5B3C750DCB4E6C7BA9B793A2D91DBE2AD22F63E6B43B6E33BE632',
      tarrantpictometryAPIKey: '481F547EDD3A0AB8191B4358CE685188',
      tarrantpictometryAPISecret:
        '9914E9A2D1E215E9901742698AB4FF67C6FF81BA24074C2865E77C4895FE52A1E23F5906F19E3D5B4007FE9707103DF9FAA2C687B588AD7CB2EAE0534DD03AC69CEACE214A7BF3D53E78F9579F8B3B59C60496A19FD898733C3D993C43C4414881D780BC4EAFFFB7161552086ECA909F225CE70434EFF8813828C575F3BE7093',
      montgomerypictometryAPIKey: 'E0D10371B7F24381844EDFC44BABC02C',
      montgomerypictometryAPISecret:
        '6BC76B4799AB41EB36400D4F89FE65873300FE4E1D87D3D211D09DA9C8962BD049892C53A5BD76F1BC603DEB13070EA8C74B2C1E7B26631FE49D04CDAFE122F327316BB6D682F7650CB3C469E37FA0A423FBA14C6C26F5E99388544999165DBCCDCE8315E98AEF597DC59DBF72A76CF83B617B9AEDC6A0484A7CF6E7589B7BB8',
    },
  },
  prod: {
    urls: {
      api: 'https://prod-container.trueprodigyapi.com',
      authApi: 'https://prod-container.trueprodigyapi.com',
      portalUI: 'https://trueprodigy-portal.com',
      publicPortalUI: 'https://trueprodigy-publicportal.com',
      recalcApi: 'https://prod-container.trueprodigyapi.com',
      appealApi: 'https://prod-container.trueprodigyapi.com',
      deedApi: 'https://prod-container.trueprodigyapi.com',
      appraisalNoticeApi: 'https://prod-container.trueprodigyapi.com',
    },
    service: {
      appealsService: 'https://prod-container.trueprodigyapi.com',
      publicService: 'https://prod-container.trueprodigyapi.com',
      userService: 'https://prod-container.trueprodigyapi.com',
      taxingUnitService: 'https://prod-container.trueprodigyapi.com',
      taxTransparencyService: 'https://prod-container.trueprodigyapi.com',
      recalculationService: 'https://prod-container.trueprodigyapi.com',
      sketchService: 'https://prod-container.trueprodigyapi.com',
      appraisalService: 'https://prod-container.trueprodigyapi.com',
      importService: 'https://prod-container.trueprodigyapi.com',
      appraisalServicePerOffice: {},
      assessmentService: 'https://prod-container.trueprodigyapi.com',
      equityfinderService: 'https://prod-container.trueprodigyapi.com',
      eventService: 'https://prod-container.trueprodigyapi.com',
      gamaService: 'https://prod-container.trueprodigyapi.com',
      hsAuditService: 'https://prod-container.trueprodigyapi.com',
      litigationService: 'https://prod-container.trueprodigyapi.com',
      mraService: 'https://prod-container.trueprodigyapi.com',
      appraisalNoticeService: 'https://prod-container.trueprodigyapi.com',
      reportService: 'https://prod-container.trueprodigyapi.com',
      s3Service: 'https://prod-container.trueprodigyapi.com',
      deedService: 'https://prod-container.trueprodigyapi.com',
      queueService: 'https://prod-container.trueprodigyapi.com',
      integrityService: 'https://prod-container.trueprodigyapi.com',
      mobileService: 'https://prod-container.trueprodigyapi.com',
      ptdService: 'https://prod-container.trueprodigyapi.com',
      exportService: 'https://prod-container.trueprodigyapi.com',
      microsoftService: 'https://prod-container.trueprodigyapi.com',
      virtualHelpService: 'https://prod-container.trueprodigyapi.com',
      conferenceService: 'https://prod-container.trueprodigyapi.com',
    },
    keys: {
      azureFunctionKey:
        'bAWG1wJbIdpX4UcyTRETAGFtc9bM8boKGPYR8xwOqLBuAzFuyQaMog==',
      azureClientId: 'f49b317a-433b-405b-b3b1-6a1ade28973e',
      bingMapAPIKey:
        'Ah3c3A46iwqv67dBO18-f_ISQ6odqWflUbqufkJKVo-ng0XvNvqVXBkG9PgiG8JB',
      googleMapAPIKey: 'AIzaSyBp6isPFklaKsVCDZmj4-7umOKerc3K_HY',
      googleMapStaticAPIKey: 'AIzaSyBp6isPFklaKsVCDZmj4-7umOKerc3K_HY',
      trueprodigypictometryAPIKey: '97CC11481FA4BAC6FAA1AF0B70FC8A9B',
      trueprodigypictometryAPISecret:
        '238E4009447FA1827FA9ABA374A5D16B75D9D43499F6AE602FC02E746290B5509F233B6DD484E8C030EB1F3C6933B8C67204E14547B8C9A6DFCF10BDBBAFDDF7014A35C5BECC939202A0816EB6AD5A28C9E79FF8156FC32A3EB84EFB0D87AEBCE0F59D817D02D3DE699C99235ADD6FECFFD80E61096C8C9422CC795CC7F80AD8',
      dentonpictometryAPIKey: '97CC11481FA4BAC6FAA1AF0B70FC8A9B',
      dentonpictometryAPISecret:
        '238E4009447FA1827FA9ABA374A5D16B75D9D43499F6AE602FC02E746290B5509F233B6DD484E8C030EB1F3C6933B8C67204E14547B8C9A6DFCF10BDBBAFDDF7014A35C5BECC939202A0816EB6AD5A28C9E79FF8156FC32A3EB84EFB0D87AEBCE0F59D817D02D3DE699C99235ADD6FECFFD80E61096C8C9422CC795CC7F80AD8',
      dentonpictometryOfficeAPIKey: 'E5D9A0362061FFF0F9D506ADF3FFA981',
      dentonpictometryOfficeAPISecret:
        'F3FA7B0ADFED1F7748AD7E002C821851FD000AA5A69F2A534457209DA1AE34447AC16BF54759A2823DDDD17B50745711BDFECC037018CBBBD4FB378B4993D745F5196651F8A7455D9BD7F283A19274E2695EF4BB61E6B4B1E9A9B7E40C5784CE3232AFB54BDD7A480CB11465976C1AA41489F5B4B675F5F640185799847D800A',
      webbpictometryAPIKey: '12C52A4CDF5767BA86C637CCE75886A7',
      webbpictometryAPISecret:
        'B7597369A85979C6649A201D1084CF8FD32D0ECE3F82B66EFDDE28BDCEAD57B2E0352DCAA0096B42C92CC80864E4D2C2BE9ECB6AEA3BC797970D2360B6581B7FC0B457D947256F57F9A666D89477FFCD077132C74EC6D3972A32920830788ED2F74BCE13279B94229AD97345FC0987F56079E5951F5198A4CA21977A11D113EA',
      webbpictometryOfficeAPIKey: '98B0D49C0C4EAC7BFA1AB0E27E38BB5C',
      webbpictometryOfficeAPISecret:
        'D672D1DEB9037FEF8E452DA577E9733A37C1EEB386997F5C9AD6B8A2E45D07084857C390C6A41B79BA147799688F96488257B741DEF1B96BE91D5885DD63D0DE151625D6352E3B68DDD9445D99DD69564CE9A2625774A2FFBB3A59B01E8644DAB6BB8F15D7E9F0DDF5945301115B2AE4DC56B86537F1139FC094E2AAD76730F1',
      collinpictometryAPIKey: 'E9AA34D875D5A180521CF3EAABAD0AA9',
      collinpictometryAPISecret:
        '4AE3D869D669A98DF5C2FA5C703B997279A6366F2634A7C02509A785BBEB6A1A5D3EBB1C5146CAD5CE0F73852B917544D6CC4BFF7EC7EF5F06317641AB7E6701978EED2440E34F0098DFA48B3D4DFD5C1CF08B990114BB1E7F31F1FF7E1EBB15005EEEE2C711C7356EB459D238B721DDBEAABEE4A9F9172769D2455B2AB15F56',
      potterrandallpictometryOfficeAPIKey: '9F8BC78EA279646022BF43887528EBB2',
      potterrandallpictometryOfficeAPISecret:
        'AFBB31586C4B39722D6A4934FED948D88281E7CE0B1CFAEF52B9490DFBC1B452B643C8E06ECFDC4F53B7D976D5A0C8C1B65D83ACF6ED554B8CE5F67339E64A0F79DC83BAA4513FB828D984125056D5E6C09E284555D7398E87CF2E879B4D0656DB740A7899B36FBC669D77281094B13FC86F434A90B2630DD36AA0C0CB8344DF',
      potterrandallpictometryAPIKey: '72D36C169E69EA0D922A7F54803A824E',
      potterrandallpictometryAPISecret:
        'F7F2B4217EAC5B6AC3A52F66F6BF9ABDE8DE15C20725D00B7BF4370D5282878C047253DD97CABDBAE5D5F51F7ABB57643508EBE21B5D7939D2B39AA1A62BE8C58D63765DE2D60EA07B4C1986CB89F6E7262C335578D4837E349BACC9A6DAD0300BA60A3D6377560B24F7C07AB26EE09CFE485367E5AF8E6A81A39E134A027923',
      valverdepictometryOfficeAPIKey: '99ED81E1B0B418FAEA905506DD4F0B4B',
      valverdepictometryOfficeAPISecret:
        'FC56433CA11CC7220158CB6698E9B1BE131E42F64770F00DC771E062C27DF1B3F5BEEB3C88F14D7079BF7950B6892A8EFEEE22BBB9418F1E6359699CAD45FE7416DA017B7C4D105F5C55227830E4E2671FD77C61167F592440672E42BC5834C3083E96AE6AE684839D33DDEAD9FDEF2432761670E8E989A1EF633A5D3515FFFB',
      valverdepictometryAPIKey: 'B966228D5B73EE95C844118BFFAA0DDC',
      valverdepictometryAPISecret:
        '7FCC39CED1F42EB2B7999623446A30BAF8CBB8D3EAC033690E7423C0ABC932A0033F71FDC9C1471867317B0B62F0599F6A582121F25461BFFD17974E7C80DE77030D2278A753AB44067A2E87BC8030AF0D667BF41F86A0574A236D9E55610764D2D64BF3C27A7D996833B2C6EB9470AFC8A8E6A0A6624236BEE80EA363643BF9',
      travispictometryAPIKey: 'EAE48C69BF12177C34B753A62713A148',
      travispictometryAPISecret:
        'C3A9C5EEBFFE34F49B7F218A44FFDA729C5364B5D9BA283A78D89E9DE96FB883F1D7F86AD167815981FF09C5255FB77876DDC2F31B804D08EBE7344DF53B2C0FB833B14DA77E90252F6786AE71E04EBF1FB79C5C41AC67C8501993D8D950EFCB9E62CD6E7ECAFCCF1C6C1293F5C66BED6481A24389D610DD213CC216D545952B',
      travispictometryOfficeAPIKey: 'A193ED52EAFCFF40ED7C2AA4EBD04ED2',
      travispictometryOfficeAPISecret:
        '722E75B273454F2176466D872A97A27CA91E4C6FDDC44C8E46B5B660EA1D29273DBE9E9B2A1160CE67F4F4D199A2F83B52EC7CDD88F57E49782CADD454A92EA737E08D8B5B3DC5A0A2498A4D30875C5B5DBFC2D0D8887A01E64A062B37544EA20E8E12D1C5F2127605701A57E567A9523573528F00C78F287C4D31CD1B29A36F',
      ellispictometryAPIKey: 'A77725E702A52D400817FF7B80928E2E',
      ellispictometryAPISecret:
        'AE303D462D7EF9C7C2AFBD79DBE7237181ADAB7DB3D662565F6C969B4E91C8168F13AC0AFD3862A42F1E17A9A726878BA27841C324C9DD1DFAF0A80DCCA4DCEF1A4FC422CE0F6E44D9145035DC97991261AB1AFA3F53F797EB4D53F8688C65DE34B739064B94DCF922B14FDA59A109D157CD5C05D98CC1BD4DEF26D77A0CD323',
      ellispictometryOfficeAPIKey: '1DE153858E7833651402442BF1C5508B',
      ellispictometryOfficeAPISecret:
        '3795709B4A0A65BEA11795E11D9463141391AB4914872B88CFF8B45ACF4D03390332FD6F6536670411F09A36C30025AA801D072E1061850EE4850371537EDE5660FB187E6E9A5A552949A24F2D257FC4B835BDCAE0B2A91B919E9A49029D553645D328D44AC50E3253175053DC2875164EFE720663A4757C31C23D37103F7501',
      maverickpictometryAPIKey: 'E8DB2D38DE032E9BA4E0A93DFB8BBADA',
      maverickpictometryAPISecret:
        'B9437CF4C4AFD491D3EE4E537C657874EF9A53E65FCF18B0B7856FC26756DB512AC23234136AC741DA2FC7CC686EA975D3A8CF690A2E4DD6D95D6410A8CD9B577B5C68C13BDF8B6ABE98B2C6C3F295C0B3F5B2F9BFD21C0394C8A4B261BB123388D1FF82AE0FC0816E38EE102DA51187D239C8C45A1A3007AEC3E6055F3949BB',
      maverickpictometryOfficeAPIKey: '092740E91016F4F6C2B4273DE660B187',
      maverickpictometryOfficeAPISecret:
        '2F0DCD7CFD9CBC57C2D4842CAFE70ED9AD6E2B07E610121D4ED276FE8F5BBAF804BCD017F1E7FF44E0A8E675AB6AFE33DCF9EAF979EDBC952A31CCAEAA20EADC35E62CBEA1DDC2BE031701E6B78303F0EF8342457E12C147D3C8746B7F5E0EF3277601C758B4F1C499C27F42242A9D91629C2EFAC79ACA7D0F4DA9DD6A70C501',
      rockwallpictometryAPIKey: '69FB36B3AF2337DB4F9E0BA67C11BDBF',
      rockwallpictometryAPISecret:
        '2A26ACFCD2D190F0F81881C10B2F3861105D611C10131B4D4A7409851DE255E26A115F890DD1EDA14F5A4EEE28B725366C9FD4AA8302100C6490440118E63D9396C12F33E3C73F46B0F8D5EFA977C5DFFC54100FB203799FC5849D7FB7079517C59C0FA19037A80C014A54689A024DF29B19A2D6964B51BACD862980530A8AD2',
      rockwallpictometryOfficeAPIKey: 'D9184788F66B5B37CF8515478687D47D',
      rockwallpictometryOfficeAPISecret:
        '51BED534242E4AF15BF6314F5563B4D1E5AEAC1702AC15D03B53AC6A1148A2130D7698456B121AE04A91E772D88510EFB9AEAEAA8838DB5750A82E4A080F0142608EB4DBAD82CD37EC1D59FDA8AC9E6036BF7AFE1E2B63D5ED0A4A55430E635D97F8FF6A4221FBD99D17D790F9148D3F10C35372D0F9F7789E91C9E85C44E704',
      cameronpictometryAPIKey: '343473445470332EB40E996EB808FE45',
      cameronpictometryAPISecret:
        'D597B53DF1E795BE73C6D30D7BFA1A67ED09905517E7433B18542E2663C99BAAAF78C02497C0B50B8303E3A9B17631119E970DF0070E31C9E8076650427ADBDFD715B9D078F0164BAAABD0120D4C389E714DDD4C015811092B02F3146568914E5D3573DD5C2D47498A5E26BD17D7C63EC60B4F6208ED0964C1ACBB0D9D776890',
      cameronpictometryOfficeAPIKey: 'FBA31F421AA8910324B2479D7EB34524',
      cameronpictometryOfficeAPISecret:
        '4D8BBDB910DD336D3706F0BBB25E72EEBF7FFCA19286D38B937DE2F986B142EC353F4A4EA0204A874A651D752161B63C32F5EEB6CA132F5B526D8110CCA2B7F88BF339C8000BA1B51F2F0838938296289ACC02A6C8AAF3A7AC119B1802D2D4BDAC505E0CB65C03FBC8C801E746C7011DEEAC8DA56F8895784C5FC788DBFB5E1B',
      reevespictometryAPIKey: '6FFF3840A2398ED677966A5BED208B27',
      reevespictometryAPISecret:
        'C6C9A3A64F03755D458246F8CB466899D618CC94F18796E24C2E4CD3211C0C6108D9F07C29C30ED9E4C7560DED63E4857F2CCEEE64A3F11E50501B4973899E8CEB047DAD50B3C4B2BCF9FF32F00FEB867591D75A8EC4766DC71227464E5949A40E5C2FB15518CD7834D62EB992151F85B81F41BCD83F5E46ADE9245AD5726A31',
      reevespictometryOfficeAPIKey: '7A5DD435D1181D5F8780D6C5418EE4B1',
      reevespictometryOfficeAPISecret:
        '18900F24B030B2BE110F619ABD1E391EB048A7113A3E9650086D0612B71C0A0AC1DAAB9424429DACE5D8D7042CECB8DD07FC4EDBE0323B9540B3F05805515A87B68AA7536F88FCC458AE1CF6320120ACB3E590382651188F4AA988660E4E5F9870502AB2DF456B746DA71A53ABBA7581856020DC69133CB99ABDABEB920612C0',
      cookepictometryAPIKey: 'CD54BB221495865A61A9414F77444DD0',
      cookepictometryAPISecret:
        '02EA204102D1DADCFE95BF6C5B52229EAB474CF9A032246D21AD94209B20CD21BE9F5A5C51D9DD05EBCF0A13BE294FF10FEFA1835C064A16AABE9C64FB288850BB92D7DDC1E66D866A873DF7411C073C276CF0775288267B808CF7B890DEDC001EC5098FA7E4D20924CA682CB74BFD06C53AD2DFC4C5D913B17FC6B799555C55',
      cookepictometryOfficeAPIKey: 'EFF2822DE36283CA39CBEE280700B394',
      cookepictometryOfficeAPISecret:
        '6CECBDB57CCDDC3C76DDD2FBE10C133D670DDA6A4E0DA2BC81E1BFC19BC77BACC7EEA1ABEC6D4FAC5741C92701E5319684F7DDA12AA2492A41476C89DDC62C6D700221790EFD10658A806E406FBBCDD69D136631C67F639D04AE1021F72A4A635762B34599436F3373AAD67019A6386D81A00FA5870E1522FD72920DE0857F63',
      hidalgopictometryAPIKey: '744D2987CF2A237AA03305BB80D56F68',
      hidalgopictometryAPISecret:
        '86F5AC6CC05C87C92205C39BA36D1B48EE03B52C80A6EDE456CBD7C6EAC87DBD742C9C75AA6CEE750480ECCA261FC108F18BA409642A596FDFD07552DC5FD0C403B0D63E30D60C608EC788079378598B98D00C6F226D02D0B6CED17E320EEBF637B64FDB4561186787536981962F914BC2BC06C5714FAFD89B7BCFCEEC76864F',
      hidalgopictometryOfficeAPIKey: '4A78ACF3B7F1289388A6A530B6ED545E',
      hidalgopictometryOfficeAPISecret:
        '8229EBEB38C6623A64BA90CA05CE85C7885B77D19C8EDFB30D1539B27320ED3090FE5F60CE7E20118B631FEC72B3D265C37EBB1EA036F904F9D579137B08C97B55B42193F705CA571D4DFC18A07DAA1C473B2C5B2F8FD17AC45FEE11941C4CCF9866B487885AEB20733FC6E1EA80983E1F66E04F1C9CF421154D8C1D76646F97',
      tarrantpictometryAPIKey: '2693A6D94E6EC9B88BE3773157A7D7B9',
      tarrantpictometryAPISecret:
        '252449E7FE43320F46FDC10F246F72C8AE623B6D44A025786A65659F6CEC53D02FB1B0C25A1F707AFB23B25B8791B44837EF913F00ADB417BEC168714BB1E7D9B88539F19D2848CED03A3359E7608E476766B019A03823AAF2213B34B0F33D618983717843555B10D52078B6BF8B566E827BEB2E8879D610EB03FBE3CAAE0A04',
      tarrantpictometryOfficeAPIKey: 'C09D43AE981DA96EF3785DA319E04DE0',
      tarrantpictometryOfficeAPISecret:
        'C3CB7B84361D657272883290EFF58F517C28B44C084F05CB4C2FF169014B0BC0F47C305099D8285A7EA8585457034202EE379A98A801ECF7F0CE83DF23DA72AE4319D0F5AC03ED5A3B943FDB39C80283994FA4DBE2FAE542BB51A72972D00628CA810FA187B24BAAE7B8E73F75F8532DC7267E5B5DCC49B27038A692D4D88DB7',
      montgomerypictometryAPIKey: 'B4843EA126C023C35C41A680C8A8B458',
      montgomerypictometryAPISecret:
        '2F187F8138A8582DF256693E6E1C33682B1857D0E548D8D48F15521809D45F46EB0C23DFE9218C6D2550C3C9B5B34B0E5D7EA3A309A86259C4053DE111EB35CE7C10B65143FABB74405E596C7F770DC9D62F50FDFA8E935A130F4D000E74F00DCEDA76533E9EDA9D661B2B8C9BB1475462D9A1820CBBF1044B61EB1A5DF9F25E',
      montgomerypictometryOfficeAPIKey: 'E612A7D91368EECCA067A759A92D6934',
      montgomerypictometryOfficeAPISecret:
        'E5FDC02BEE423170AE67C5E7D91A7F8B20E48181204A95E2066B7C59BCC4E6D3212EA91F71BECDE7D7B388E4D02DF5EAC5422695D644EA5A3AFE584C9E4F477D6C2D603FC457E13AAAFDAC080E515B3E4C52B00CA7F3811F15740D2DB5DAFBFF0E0A2031BB2460CC638BCDCB5022513F8C8561688C88F27B91806EA4DBF65C8F',
      clientID: 'ee55134e-1e6a-4ceb-bc24-1537d75a6d76',
    },
  },
};
